/**
 * The width every page uses, so content does not jump sideways between pages:
 *   standard (1200px) — most pages: profile, lab, consortium, works, interests, notifications…
 *   wide     (1536px) — pages of many cards or wide tables: funding calls, hub, messages, admin
 *   narrow   ( 900px) — forms: edit pages, a position
 * The cap is in pixels, not MUI breakpoints: breakpoints follow the window, so with the sidebar collapsed
 * the same window gave a page a different width. Same side gutters (16px on phones, 24px from tablets up)
 * and the same, small space above (content starts close under the app bar) and below.
 * sx is merged in for a page's own needs (keep its width from here).
 */
import React from 'react';
import { Box } from '@mui/material';

export const PAGE_WIDTHS = { standard: 1200, wide: 1536, narrow: 900 };

export default function PageContainer({ width = 'standard', sx, children, ...rest }) {
  return (
    <Box {...rest}
      sx={{ width: '100%', maxWidth: PAGE_WIDTHS[width] || PAGE_WIDTHS.standard, mx: 'auto', boxSizing: 'border-box',
        px: { xs: 2, sm: 3 }, pt: 2, pb: 4, ...sx }}>
      {children}
    </Box>
  );
}
